/* eslint-disable no-nested-ternary */
import { useState, useEffect } from 'react';
import {
 commitMutation, graphql, useRelayEnvironment, useFragment,
} from 'react-relay';
import { nanoid } from 'nanoid';
import Icon from '@/core/icon';
import { useZusUserConnectedStore } from '@/helpers/user-auth.js';
import { fragment as headerBookmarkFragment } from '@/components/header/bookmark';

const setBookmark = graphql`
  mutation bookmarksetBySpaceIdMutation ($userRef: String!, $spaceId: String!) {
    result: setSpaceBookmark(userRef: $userRef, spaceId: $spaceId) {
      code
      success
      message
    }
  }
`;

const unsetBookmark = graphql`
  mutation bookmarkunsetBySpaceIdMutation ($userRef: String!, $spaceId: String!) {
    result: unsetSpaceBookmark(userRef: $userRef, spaceId: $spaceId) {
      code
      success
      message
    }
  }
`;

const onClickMutation = (environment, variables, type, callback) => commitMutation(
  environment,
  {
    mutation: type === 'set' ? setBookmark : unsetBookmark,
    variables: { ...variables },
    onCompleted: (res) => {
      callback(res.result);
    },
    onError: (err) => console.error(err),
  },
);

function Bookmark({ spaceId, className, iconClassName }) {
  const environment = useRelayEnvironment();
  const userData = useZusUserConnectedStore((state) => state.userData);
  const isAuthenticated = useZusUserConnectedStore((state) => state.isAuthenticated);
  const userAuthOpenModal = useZusUserConnectedStore((state) => state.userAuthOpenModal);

  const [step, setStep] = useState(isAuthenticated ? 'logged' : 'needConnecting');

  // eslint-disable-next-line max-len
  const userDataBk = userData?.bookmark || null;
  const fragmentBookmark = useFragment(headerBookmarkFragment, userDataBk);
  const spaceIds = fragmentBookmark?.spaceIds || [];
  const bookmark = spaceIds.includes(spaceId);
  const [isBookmark, setIsBookmark] = useState(bookmark);

  const callMutation = () => {
    if (!spaceId) return null;
    const userRef = userData?.ref;
    return onClickMutation(environment, { userRef, spaceId }, isBookmark ? 'unset' : 'set', (res) => {
      if (!res || !res.success) return null;
      useZusUserConnectedStore.setState({ forceReloadUser: nanoid() });
      return setIsBookmark(!isBookmark);
    });
  };

  const onClick = (e) => {
    if (e) e?.stopPropagation();
    if (!spaceId) return null;
    if (!isAuthenticated) {
      userAuthOpenModal('signup');
      setStep('waitConnecting');
      return null;
    }
    return callMutation();
  };

  useEffect(() => {
    setIsBookmark(bookmark);
  }, [bookmark]);

  useEffect(() => {
    if (isAuthenticated && userData?.ref && step === 'waitConnecting') {
      callMutation();
    }
  }, [isAuthenticated, userData]);

  return (
    <span className={`${className}`} onClick={onClick}>
      <Icon
        name="heart"
        className={`w-6 h-6 transition-all duration-300 ease-in-out 
          ${iconClassName ? 'stroke-current' : 'fill-current'} 
          ${isBookmark
            ? (iconClassName ? 'text-red' : 'text-red')
            : (iconClassName ? 'text-purple-6 group-hover:text-purple' : 'text-white group-hover:text-purple-0')} 
          `}
      />
    </span>
  );
}

export default Bookmark;
